import moment from "moment";

// Extraido de components/Dashboard/TableAttendantsStatus.js (projeto
// "layout novo" 2026-10-21) pra poder ser usado tambem pela versao Nova
// do Dashboard sem duplicar a logica - mesma funcao, mesmo resultado,
// so' mudou de lugar. TableAttendantsStatus.js agora importa daqui em
// vez de ter a propria copia.
export function formatTime(minutes) {
  return moment().startOf("day").add(minutes || 0, "minutes").format("HH[h] mm[m]");
}

// Dicas automaticas baseadas em regras simples comparando cada atendente
// com a media do time (quem tem >30% de espera/atendimento acima da
// media, ou nota baixa, recebe um aviso). Sem IA, sem custo, calculado
// na hora.
export function getDicas(attendant, teamAvg) {
  const dicas = [];

  if (teamAvg.avgWaitTime && attendant.avgWaitTime > teamAvg.avgWaitTime * 1.3) {
    dicas.push({ text: "Espera acima da média", color: "warning" });
  }
  if (teamAvg.avgSupportTime && attendant.avgSupportTime > teamAvg.avgSupportTime * 1.3) {
    dicas.push({ text: "Atendimento demorado", color: "warning" });
  }
  if (attendant.rating != null && attendant.rating > 0 && attendant.rating < 2) {
    dicas.push({ text: "Nota baixa", color: "error" });
  }
  if (dicas.length === 0 && (attendant.tickets || 0) > 0) {
    dicas.push({ text: "Dentro da média", color: "default" });
  }
  return dicas;
}

export function computeTeamAverages(attendants) {
  const withTickets = attendants.filter((a) => (a.tickets || 0) > 0);
  const avg = (key) => {
    const values = withTickets.map((a) => a[key]).filter((v) => v != null && !isNaN(v));
    if (!values.length) return null;
    return values.reduce((sum, v) => sum + v, 0) / values.length;
  };
  return {
    avgWaitTime: avg("avgWaitTime"),
    avgSupportTime: avg("avgSupportTime"),
  };
}
